import { Alert, Button, Form, FormInstance, Input, Modal, Space } from "antd";
import React, { useEffect } from "react";
import {
  CreateHallPayload,
  GetHallFloorPayload,
  GetHallRoomPayload,
  HallRoom,
  UpdateHallFloorPayload,
  UpdateHallPayload,
  UpdateHallRoomPayload,
} from "../../interfaces";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch } from "react-redux";
import { appSelector } from "../../helpers/appSelector";
import { ModalSpinner, Spinner } from "../common/Spinner";
import { getHallRoom } from "../../store/hallRooms";

interface Props {
  open: boolean;
  onCancel: () => void;
  form: FormInstance<UpdateHallRoomPayload>;
  onFinish: ((values: UpdateHallRoomPayload) => void) | undefined;
  room?: HallRoom;
}

const UpdateHallFloorForm = ({
  open,
  onCancel,
  form,
  onFinish,
  room,
}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const payload: GetHallRoomPayload = {
      id: room?.id,
      floor_id: room?.floor?.id || "",
      hall_id: room?.floor?.hall?.id || "",
    };
    room?.id && dispatch(getHallRoom(payload));
  }, [dispatch, room]);

  const {
    floor,
    loading: loadingHallRoom,
    isHallRoomSubmitting,
    success,
  } = appSelector((state) => state.hallRoomStore);

  useEffect(() => {
    success && onCancel();
  }, [success]);

  const initialValues: UpdateHallFloorPayload = {
    name: room?.name || "",
    description: room?.description || "",
    hall_id: room?.floor?.hall?.id || "",
    id: room?.floor?.id || "",
  };

  form.setFieldsValue(initialValues);

  return (
    <Modal
      title="Update Floor"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button type="default" key="cancel" onClick={() => onCancel()}>
          Close
        </Button>,
        <Button
          form="hallUpdateForm"
          key="submit"
          htmlType="submit"
          type="primary"
          loading={isHallRoomSubmitting}
        >
          {isHallRoomSubmitting ? "Updating.." : "Update"}
        </Button>,
      ]}
    >
      <Form<UpdateHallRoomPayload>
        form={form}
        layout="vertical"
        id="hallUpdateForm"
        name="hallUpdateForm"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        {loadingHallRoom ? (
          <ModalSpinner />
        ) : (
          <>
            <Form.Item hidden name="hall_id">
              <Input hidden value={room?.floor?.hall?.id} />
            </Form.Item>
            <Form.Item hidden name="floor_id">
              <Input hidden value={room?.floor?.id} />
            </Form.Item>
            <Alert
              message={
                <div>
                  <div>
                    <strong>Hall:</strong> {`${room?.floor?.hall?.name}`}
                  </div>
                  <div>
                    <strong>Floor:</strong> {`${room?.floor?.name}`}
                  </div>
                </div>
              }
            />
            <Form.Item
              name="name"
              label="Room Name"
              rules={[
                {
                  required: true,
                  message: "Please input the name of the room!",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>

            <Form.Item name="description">
              <TextArea allowClear rows={5} />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default UpdateHallFloorForm;
